import React from 'react'
import Skeleton from '@mui/material/Skeleton';
const LoadingProductCell = () => {
  return (
    <>
    <div className="product-card product-card--layout--grid d-flex bg-white position-relative rounded">
                <div className="product-card__image">
                    <div className="image image--type--product p-3">
                        <Skeleton variant="rectangular" width={'100%'} height={215} />
                    </div>
                </div>
                <div className="product-card__info">
                    <div className="product-card__meta"> <Skeleton animation="wave" /></div>
                    <div className="product-card__name"> <Skeleton animation="wave" /></div>
                    <div className="product-card__desc"> <Skeleton animation="wave" /></div>
                </div>
                <div className="product-card__footer">
                    <div className="product-card__prices">
                        <Skeleton width={'90%'} animation="wave" height={50}  />
                    </div>
                    <div className="product-card__prices">
                        <Skeleton width={'90%'} animation="wave" height={50}  />
                    </div>
                </div>
            </div>
    </>
  )
}

export default LoadingProductCell